import { useContext, useEffect } from 'react';
import { dataStore } from 'store/data';
import { appStore } from 'store/app';
import { getCustomData } from 'config-app/initial-state';

const useCustomData = () => {
  const [dataState] = useContext(dataStore);
  const [appState, setAppState] = useContext(appStore);

  // ユーザ選択の状態から customData を生成してステート更新
  useEffect(() => {
    setAppState({
      ...appState,
      customData: getCustomData(appState.steps, dataState),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appState.steps, dataState]);
};

export default useCustomData;
